import axios from "axios";
//const baseURL = "http://localhost:63130/api";
const baseURL = "https://190.223.56.84/api";
export default axios.create({
    baseURL,
});